var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"contents"},[_c('div',{staticClass:"section"},[_c('h1',[_vm._v("Page Not Found")]),_c('h2',[_vm._v("お探しのページが見つかりません")]),_c('p',[_vm._v(" URLに間違いないか確認し、再度アクセスを試してください。"),_c('br'),_vm._v(" また、つながらない場合は時間をおいて再度アクセスしてください。 ")])])])])])
}]

export { render, staticRenderFns }